module.exports = __webpack_public_path__ + "img/main_partnerbg.a14de9b7.png";